import { Routes, Route, Navigate } from 'react-router-dom';

// Layouts
import { PublicLayout, AppLayout } from './components/layout';

// Components
import { ProtectedRoute, TeacherRoute, StudentRoute } from './components/common';

// Public Pages
import { Landing, Login, StudentLogin, Register } from './pages/public';

// App Pages (Student View)
import { Home, Leaderboard, Badges, Profile, WeekDetail } from './pages/app';

// Teacher Pages
import { Dashboard as TeacherDashboard, Students as TeacherStudents, StudentDetail, Progress as TeacherProgress, Certificates as TeacherCertificates } from './pages/teacher';

export default function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/student-login" element={<StudentLogin />} />
        <Route path="/register" element={<Register />} />
      </Route>

      {/* Protected App Routes (Student View) - Only students */}
      <Route
        path="/app"
        element={
          <StudentRoute>
            <AppLayout />
          </StudentRoute>
        }
      >
        <Route index element={<Home />} />
        <Route path="leaderboard" element={<Leaderboard />} />
        <Route path="badges" element={<Badges />} />
        <Route path="profile" element={<Profile />} />
        <Route path="week/:weekNumber" element={<WeekDetail />} />
      </Route>

      {/* Protected Teacher Routes - Only teachers */}
      <Route
        path="/teacher"
        element={
          <TeacherRoute>
            <TeacherDashboard />
          </TeacherRoute>
        }
      />
      <Route
        path="/teacher/students"
        element={
          <TeacherRoute>
            <TeacherStudents />
          </TeacherRoute>
        }
      />
      <Route
        path="/teacher/students/:studentId"
        element={
          <TeacherRoute>
            <StudentDetail />
          </TeacherRoute>
        }
      />
      <Route
        path="/teacher/progress"
        element={
          <TeacherRoute>
            <TeacherProgress />
          </TeacherRoute>
        }
      />
      <Route
        path="/teacher/certificates"
        element={
          <TeacherRoute>
            <TeacherCertificates />
          </TeacherRoute>
        }
      />

      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
